"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { ArrowRight } from "lucide-react";
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 12,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
function CategoryGridConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-2 gap-4 md:gap-6 md:grid-cols-3 lg:grid-cols-4">
        {[...Array(8)].map((_, i) => <Card key={i} data-index={i} className="animate-pulse border-transparent shadow-md bg-card rounded-lg">
            <CardContent className="flex flex-col items-center justify-center p-6 h-56">
              <div className="w-20 h-20 bg-muted rounded-lg mb-4"></div>
              <div className="h-4 w-24 bg-muted rounded mb-2"></div>
              <div className="h-3 w-16 bg-muted rounded"></div>
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-destructive py-12 bg-card rounded-lg shadow-md">
        <p className="font-default">Failed to load land solutions. Please try again later.</p>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return <div className="text-center text-muted-foreground py-12 bg-card rounded-lg shadow-md">
        <p className="font-default">No service categories available at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-2 gap-4 md:gap-6 md:grid-cols-3 lg:grid-cols-4">
      {terms.map((term, i) => <Card key={term.id} data-index={i} className="group border-transparent shadow-md hover:shadow-lg transition-all duration-300 bg-card overflow-hidden flex flex-col rounded-lg">
          <CardContent className="flex flex-col items-center text-center p-6 flex-grow justify-between">
            <div className="flex flex-col items-center w-full">
              {term.image_url ? <div className="w-24 h-24 mb-6 flex items-center justify-center overflow-hidden">
                  <img src={term.image_url} alt={term.name} className="max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-110" loading="lazy" />
                </div> : <div className="w-24 h-24 mb-6 bg-muted rounded-lg flex items-center justify-center shadow-sm">
                  <span className="text-muted-foreground text-xs font-default uppercase tracking-wider">Service Icon</span>
                </div>}
              
              <h3 className="font-default font-bold text-base md:text-lg text-secondary mb-2 line-clamp-2">
                {term.name}
              </h3>
              
              {term.description && <p className="text-xs md:text-sm text-muted-foreground font-default line-clamp-2 mb-4">
                  {term.description}
                </p>}
            </div>

            {term.link && <Link to={term.link} className="mt-4 inline-flex items-center text-sm font-bold text-primary hover:text-primary/80 transition-colors uppercase tracking-widest">
                Learn More
                <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1 text-primary" />
              </Link>}
          </CardContent>
        </Card>)}
    </div>;
}
export default function CategoryGrid() {
  return;
}